import { Map } from 'immutable';

import * as types from './types';

const initialState = Map({
  loading: true,
});

const teamManagementReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.INITIAL_DATA.REQUEST:
      return state.set('loading', true);
    case types.INITIAL_DATA.SUCCESS:
    case types.INITIAL_DATA.FAILURE:
      return state.set('loading', false);
    case types.TOGGLE_LOADING:
      return state.set('loading', payload);
    default:
      return state;
  }
};

export default teamManagementReducer;
